import { Box, Stack } from "@mui/material";
import {
  AuthenticatedApp,
  NavigationLogger,
  NotificationStack,
} from "@redriver/cinnamon-mui";
import { EnvironmentBanner } from "components/banners";
import Header from "./Header";
import NavMenu from "./NavMenu";
import Content from "./Content";

const Shell = () => (
  <AuthenticatedApp>
    <NavigationLogger />
    <EnvironmentBanner />
    <Box display="flex" flexDirection="column" height="100%">
      <Header />
      <Stack direction="row" flex="1" height="calc(100vh - 65px)">
        <NavMenu />
        <Content>Cinnamon MUI Docs</Content>
      </Stack>
    </Box>
    <NotificationStack />
  </AuthenticatedApp>
);

export default Shell;
